import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from '../../../../../units/Box/Box';
import Text from '../../../../../units/Text/Text';

const Wrapper = styled(Flex)`
  height: 18px;
`;

const StyledText = styled(Text).attrs({
  size: '18px'
})`
  text-transform: uppercase;
`;

const StyledValue = styled(StyledText)`
  margin-left: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const OrgsDropdownValue = props => {
  const label = props.value.name;
  return (
    <Wrapper>
      <StyledValue>{label || 'выбрать'}</StyledValue>
    </Wrapper>
  );
};

OrgsDropdownValue.propTypes = {
  value: PropTypes.object
};

OrgsDropdownValue.defaultProps = {
  value: null
};

export default OrgsDropdownValue;



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/RegistratUserOrgResult/OrgsDropdownValue/OrgsDropdownValue.js